import React from 'react';
import { Helmet } from 'react-helmet';
import bannerBg from '../assets/img/page-banner.jpg';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';
import PageBanner from '../components/PageBanner';
import Services2 from '../components/Services2';

function Services() {
    return (
        <>
            <Helmet>
                <title>Servicii Construcții și Renovări București - Work Express</title>
                <meta name="description" content="Servicii complete de construcții și renovări: izolații, hidroizolații, instalații electrice, vopsitorie, gips-carton, tencuieli, șape, pardoseli, AC, HVAC și IBIX. Calitate garantată în București." />
                <meta name="keywords" content="servicii constructii bucuresti, izolatii termoizolante, hidroizolatii, instalatii electrice, vopsitorie tapet, gips-carton, tencuieli, sape autonivelante, pardoseli, instalare AC, HVAC, IBIX" />
                <meta property="og:title" content="Servicii Profesionale Construcții - Work Express București" />
                <meta property="og:description" content="10 servicii specializate pentru toate nevoile tale de construcții și renovări." />
                <link rel="canonical" href="https://workexpress.ro/servicii" />
            </Helmet>
            <Header1 />
            <PageBanner bannerBg={bannerBg} currentPage="Servicii" heading="Serviciile Noastre" />
            <Services2 />
            <Footer1 />
        </>
    );
}

export default Services;
